<template>
  <div id="app">
    <div id="main-body">
      <main-page @logged-in="loggedIn" v-show="!accessToken" />
      <organisation-form :latestVersionUrl="latestVersionUrl" :accessToken="accessToken" v-show="accessToken && !organisationId" @selected-organisation-id="selectedOrganisationId" @log-out="logout" />
      <licence-form :latestVersionUrl="latestVersionUrl" :accessToken="accessToken" :organisationId="organisationId" v-show="organisationId && !licenceId" @selected-licence-id="selectedLicenceId" @re-select-organisation="reselectOrganisation" @log-out="logout" />
      <licence-details :latestVersionUrl="latestVersionUrl" :accessToken="accessToken" :licenceId="licenceId" :email="email" :organisationId="organisationId" :organisationName="organisationName" v-show="licenceId" @re-select-licence="reselectLicence" @log-out="logout" />
    </div>
  </div>
</template>

<script>
import MainPage from './components/MainPage.vue'
import OrganisationForm from './components/OrganisationForm.vue'
import LicenceForm from './components/LicenceForm.vue'
import LicenceDetails from './components/LicenceDetails.vue'

export default {
  name: 'App',
  components: {
    MainPage,
    OrganisationForm,
    LicenceForm,
    LicenceDetails,
  },
  data() {
    return {
      email: '',
      accessToken: '',
      organisationId: '',
      organisationName: '',
      licenceId: '',
      latestVersionUrl: 'https://incrowdsports.com/'
    }
  },
  methods: {
    logout() {
      this.email = ''
      this.accessToken = ''
      this.organisationId = ''
      this.organisationName = ''
      this.licenceId = ''
    },
    reselectOrganisation() {
      this.organisationId = ''
      this.organisationName = ''
      this.licenceId = ''
    },
    reselectLicence() {
      this.licenceId = ''
    },
    async loggedIn(email, accessToken) {
      this.email = email
      this.accessToken = accessToken

      var myHeaders = new Headers();
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      const baseUrl = `https://${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : 'stage-'}cast-licensing-api.incrowdsports.com/v1`
      var response = await fetch(`${baseUrl}/cast-versions/1.0.0.0`, requestOptions)
        .then(response => response.json())
        .then(data => {
          return data.data
        })
        .catch(error => console.log('error', error))

      this.latestVersionUrl = response.url
    },
    selectedOrganisationId(organisationId, organisationName) {
      this.organisationId = organisationId
      this.organisationName = organisationName
    },
    selectedLicenceId(licenceId) {
      this.licenceId = licenceId
    },
  }
}
</script>

<style>
#app {
  font-family: 'Roboto';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
#main-body {
  min-height: 100vh;

  background: rgba(35, 37, 45, 1);
}
</style>
